<template>
  <div>
    <Navbar />
    <div class="w-section page-header">
      <div
        data-ix="navbar-grow"
        class="page-header-overlay"
      >
        <div class="w-container container">
          <h1
            data-ix="fade-in-on-load"
            class="w-editable page-header-title"
          >
            About us
          </h1>
        </div>
      </div>
    </div>
    <div class="w-section section">
      <div class="w-container container home-intro-container">
        <div class="w-row home-intro-row">
          <div class="w-col w-col-4 home-intro-column">
            <div class="w-clearfix home-intro-block">
              <img
                src="/images/Icon-suitcase-black.png"
                data-ix="fade-in-on-load-2"
                class="w-editable intro-block-icon"
              >
              <div
                data-ix="fade-in-on-load-2"
                class="w-editable intro-block-title"
              >
                Our office
              </div>
              <p
                data-ix="fade-in-on-load-2"
                class="w-editable"
              >
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                varius enim in eros elementum tristique. Duis cursus, mi quis viverra
                ornare, eros dolor interdum nulla, ut commodo.
              </p>
              <router-link
                :to="{ name: 'Contact' }"
                data-ix="fade-in-on-load-2"
                class="w-editable link learn-more fixed"
              >
                Contact us
              </router-link>
            </div>
          </div>
          <div class="w-col w-col-4 home-intro-column">
            <div class="w-clearfix home-intro-block">
              <img
                src="/images/Icon-user.png"
                data-ix="fade-in-on-load-3"
                class="w-editable intro-block-icon"
              >
              <div
                data-ix="fade-in-on-load-3"
                class="w-editable intro-block-title"
              >
                Our team
              </div>
              <p
                data-ix="fade-in-on-load-3"
                class="w-editable"
              >
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                varius enim in eros elementum tristique. Duis cursus, mi quis viverra
                ornare, eros dolor interdum nulla, ut commodo.
              </p>
              <router-link
                :to="{ name: 'OurTeam' }"
                data-ix="fade-in-on-load-3"
                class="w-editable link learn-more fixed"
              >
                Meet the team
              </router-link>
            </div>
          </div>
          <div class="w-col w-col-4 home-intro-column">
            <div class="home-intro-block last">
              <img
                src="/images/Icon-megaphone.png"
                data-ix="fade-in-on-load-4"
                class="w-editable intro-block-icon"
              >
              <div
                data-ix="fade-in-on-load-4"
                class="w-editable intro-block-title"
              >
                Job opening!
              </div>
              <p
                data-ix="fade-in-on-load-4"
                class="w-editable"
              >
                Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
                varius enim in eros elementum tristique. Duis cursus, mi quis viverra
                ornare, eros dolor interdum null.
              </p>
              <router-link
                to="/404"
                data-ix="fade-in-on-load-4"
                class="w-editable link learn-more fixed"
              >
                Learn more
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <div class="w-container container info-container">
        <div
          data-ix="fade-in-on-scroll-2"
          class="info-text-block"
        >
          <div class="w-editable intro-block-title">
            Our team
          </div>
          <p class="w-editable">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
            Suspendisse varius enim in eros elementum tristique. Duis cursus,
            mi quis viverra ornare, eros dolor interdum nulla, ut commodo diam
            libero vitae erat.&nbsp;Lorem ipsum.
          </p>
          <router-link
            :to="{ name: 'OurTeam' }"
            data-ix="fade-in-on-load-3"
            class="w-editable link learn-more"
          >
            Meet the team
          </router-link>
        </div>
        <div
          data-ix="fade-in-on-scroll"
          class="info-image-block"
        />
      </div>
      <div class="w-container container info-container last">
        <div
          data-ix="fade-in-on-scroll"
          class="info-text-block left"
        >
          <div class="w-editable intro-block-title">
            Our projects
          </div>
          <p class="w-editable">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse
            varius enim in eros elementum tristique. Duis cursus, mi quis viverra
            ornare, eros dolor interdum nulla, ut commodo diam libero vitae
            erat.&nbsp;Lorem ipsum dolor.
          </p>
          <router-link
            :to="{ name: 'Portfolio' }"
            class="w-editable link learn-more"
          >
            Learn more
          </router-link>
        </div>
        <div
          data-ix="fade-in-on-scroll-2"
          class="info-image-block about-us-2"
        />
      </div>
    </div>
    <div class="w-section section white stats">
      <div class="w-container container">
        <div class="w-row stats-row">
          <div class="w-col w-col-3 w-col-small-6 w-col-tiny-6 stats-col">
            <div class="stats-block">
              <div class="stats-title">
                20
              </div>
              <div class="stats-title description">
                Years in business
              </div>
            </div>
          </div>
          <div class="w-col w-col-3 w-col-small-6 w-col-tiny-6 stats-col">
            <div class="stats-block">
              <div class="stats-title">
                500,000+
              </div>
              <div class="stats-title description">
                Users
              </div>
            </div>
          </div>
          <div class="w-col w-col-3 w-col-small-6 w-col-tiny-6 stats-col">
            <div class="stats-block">
              <div class="stats-title">
                $100M+
              </div>
              <div class="stats-title description">
                In transactions
              </div>
            </div>
          </div>
          <div class="w-col w-col-3 w-col-small-6 w-col-tiny-6 stats-col">
            <div class="stats-block">
              <div class="stats-title">
                9
              </div>
              <div class="stats-title description">
                team members
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/TheNavbar'
import Footer from '@/components/TheFooter'

export default {
  name: 'AboutUs',
  components: {
    Navbar,
    Footer,
  },
  mounted() {
    setTimeout(() => {
      // eslint-disable-next-line
      $(Webflow.ready)
    }, 1)
  },
  destroyed() {
    // eslint-disable-next-line
    $(Webflow.destroy)
  },
}
</script>
